import React, { useState } from "react";
import { all_routes } from "../router/all_routes";
import { useNavigate } from "react-router-dom";
import ImageWithBasePath from "../../core/data/img/ImageWithBasePath";
import { LANG } from "../../constants/language";
import * as Yup from "yup";
import { useFormik } from "formik";
import { forgotPassword } from "../../services/auth.service";
import { toast } from "react-toastify";
import { emailRegex } from "../../constants/utlis";

const initialValues = {
  email: "",
};

const forgotPasswordSchema = Yup.object().shape({
  // email: Yup.string().email('Wrong email format').min(3, 'Minimum 3 symbols').max(50, 'Maximum 50 symbols').required(LANG.EMAIL_IS_REQUIRED),
  email: Yup.string()
    .required(LANG.EMAIL_IS_REQUIRED)
    .matches(emailRegex, LANG.PLEASE_ADD_VALID_EMAIL),
});

const EmailPassword = () => {
  const routes = all_routes;
  const navigate = useNavigate();
  const [error, setError] = useState<any>(null);

  const formik = useFormik({
    initialValues,
    validationSchema: forgotPasswordSchema,
    onSubmit: async (values, { setStatus, setSubmitting }) => {
      try {
        const {
          data: { result },
        } = await forgotPassword(values.email);
        console.log(result);
        toast.success("Password reset link sent successfully!");
        setError(null);

        navigate("/auth/confirm-email", { state: { email: values.email } });
      } catch (error) {
        setSubmitting(false);
        setStatus("The login detail is incorrect");
        toast.error(LANG.EMAIL_NOT_FOUND);
        setError(LANG.EMAIL_NOT_FOUND);
      }
    },
  });

  return (
    <div className="main-wrapper authendication-pages forgot-password">
      {/* Page Content */}
      <div className="content">
        <div className="container wrapper no-padding">
          <div className="row no-margin  align-items-stretch">
            <div className="col-12 col-sm-12 col-lg-8 no-padding d-flex">
              <div className="banner-bg banner-bg-1 login">
                <div className="row h100">
                  <div className="col-sm-12 col-md-12 col-lg-12">
                    <div className="row h-100">
                      <div className="col-md-12 h-100">
                        <img
                          src="/assets/img/authImg.jpg"
                          className="object-fit-cover img-fluid w-100"
                          alt="authImg"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-12 col-sm-12  col-lg-4 no-padding mt-2">
              <div className="dull-pg ">
                <div className="row no-margin vph-100 d-flex align-items-top justify-content-center">
                  <div className="col-sm-10 col-md-10 col-lg-11 mx-auto  d-flex align-items-center justify-content-center">
                    <div className="shadow-card d-flex align-items-top justify-content-center">
                      <div className="shadow-card-inner">
                        <header className="text-center">
                          <ImageWithBasePath
                            src="assets/img/logo.svg"
                            className="img-fluid"
                            alt="Logo"
                          />
                        </header>
                        <h2 className="text-center">Check your email</h2>
                        <p className="text-center">
                          We’ve sent you a password reset link to your email
                          “user*******@gmail.com”. Please check mail and follow
                          the instructions.
                        </p>

                        <div className="tab-content" id="myTabContent">
                          <div
                            className="tab-pane fade show active"
                            id="user"
                            role="tabpanel"
                            aria-labelledby="user-tab"
                          >
                            <form onSubmit={formik.handleSubmit}>
                              <button
                                type="submit"
                                className="btn btn-primary primaryButton register-btn d-inline-flex justify-content-center align-items-center w-100 btn-block"
                              >
                                Continue to login
                              </button>
                            </form>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* /Page Content */}
    </div>
  );
};

export default EmailPassword;
